import React from 'react';
import PropTypes from 'prop-types'; 
import AuthContextProvider from './AuthContext'; 
import AgentContextProvider from './AgentContext';
import MealContextProvider from './MealContext';
import RestaurantContextProvider from './RestaurantContext';
import PermissionContextProvider from './PermissionContext';
import ThemeContextProvider from './ThemeContext';
import BookingContextProvider from './BookingContext';
import SideBarRefreshContextProvider from './SideBarRefreshContext';
import GlobalContextProvider from './GlobalContext';

const AppContextProvider = ({ children }) => (
  <SideBarRefreshContextProvider>
    <GlobalContextProvider>
      <ThemeContextProvider>
        <AuthContextProvider>
          <PermissionContextProvider>
            <BookingContextProvider>
              <AgentContextProvider>
                <MealContextProvider>
                  <RestaurantContextProvider>
                    {children}  
                  </RestaurantContextProvider>
                </MealContextProvider>
              </AgentContextProvider>
            </BookingContextProvider>
          </PermissionContextProvider>
        </AuthContextProvider>
      </ThemeContextProvider>
    </GlobalContextProvider>
    
  </SideBarRefreshContextProvider>
  
  
  );

AppContextProvider.propTypes = {
  children: PropTypes.node.isRequired, 
};

export default AppContextProvider;
